import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const colors = {
  c1: "#9734eb",
  c2: "#0f0fff",
  c3: "#fff",
  c4: "#00feff",
}

const RecommendationsIcon = () => {
  return (
    <span className="recommendations-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <motion.g
          animate={{
            x: [0, -14.5, -14.5, -29, -29, 0],
            y: [0, 9.4, 9.4, 0, 0, 0],
            scale: [1, 1.26, 1.26, 1, 1, 1],
          }}
          transition={{
            ease: "linear",
            times: [0, 0.2, 0.4, 0.6, 0.8, 1],
            duration: 6,
            repeat: Infinity,
            repeatDelay: 1.2,
          }}
        >
          <g id="human_3_bottom_2">
            <motion.ellipse
              cx="38.7"
              cy="28"
              rx="9.3"
              ry="4.69"
              animate={{
                fill: [
                  colors.c3,
                  colors.c1,
                  colors.c1,
                  colors.c3,
                  colors.c3,
                  colors.c3,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_3_bottom">
            <motion.ellipse
              cx="38.69"
              cy="27.34"
              rx="6.71"
              ry="3.08"
              animate={{
                fill: [
                  colors.c4,
                  colors.c2,
                  colors.c2,
                  colors.c4,
                  colors.c4,
                  colors.c4,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_3_body">
            <motion.path
              d="M43.14,18.5c-.38.97-.98,1.57-.98,1.57-.16,1.39-.32,2.54-.47,3.49-.06.36-.11.68-.16.99-.51,2.97-.87,3.45-.87,3.45h-3.94s-.36-.48-.87-3.45c-.05-.3-.11-.63-.16-.99-.15-.95-.31-2.1-.47-3.49,0,0-.6-.6-.98-1.57,0,0-.91-3.29-.38-8.45,0,0,.4-.99,4.06-1.61.25.04.51.07.78.07s.52-.03.77-.07c3.65.62,4.05,1.6,4.05,1.6.53,5.16-.37,8.45-.37,8.45Z"
              animate={{
                fill: [
                  colors.c1,
                  colors.c4,
                  colors.c4,
                  colors.c1,
                  colors.c1,
                  colors.c1,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_3_head">
            <path
              className="cls-3"
              d="M42.56,3.83c0,1.85-1.32,3.4-3.09,3.76-.25.05-.51.08-.77.08s-.53-.03-.78-.08c-1.76-.36-3.08-1.9-3.08-3.75,0-2.11,1.73-3.83,3.86-3.83s3.86,1.72,3.86,3.83Z"
            />
          </g>
        </motion.g>
        <motion.g
          animate={{
            x: [0, 29, 29, 14.5, 14.5, 0],
            y: [0, 0, 0, 9.4, 9.4, 0],
            scale: [1, 1, 1, 1.26, 1.26, 1],
          }}
          transition={{
            ease: "linear",
            times: [0, 0.2, 0.4, 0.6, 0.8, 1],
            duration: 6,
            repeat: Infinity,
            repeatDelay: 1.2,
          }}
        >
          <g id="human_1_bottom_2">
            <motion.ellipse
              cx="9.3"
              cy="28"
              rx="9.3"
              ry="4.69"
              animate={{
                fill: [
                  colors.c3,
                  colors.c3,
                  colors.c3,
                  colors.c1,
                  colors.c1,
                  colors.c3,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_1_bottom">
            <motion.ellipse
              cx="9.28"
              cy="27.34"
              rx="6.71"
              ry="3.08"
              animate={{
                fill: [
                  colors.c4,
                  colors.c4,
                  colors.c4,
                  colors.c2,
                  colors.c2,
                  colors.c4,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_1_body">
            <motion.path
              d="M13.73,18.5c-.38.97-.98,1.57-.98,1.57-.16,1.39-.32,2.54-.47,3.49-.06.36-.11.68-.16.99-.51,2.97-.87,3.45-.87,3.45h-3.94s-.36-.48-.87-3.45c-.05-.3-.11-.63-.16-.99-.15-.95-.31-2.1-.47-3.49,0,0-.6-.6-.98-1.57,0,0-.91-3.29-.38-8.45,0,0,.4-.99,4.06-1.61.25.04.51.07.78.07s.52-.03.77-.07c3.65.62,4.05,1.6,4.05,1.6.53,5.16-.37,8.45-.37,8.45Z"
              animate={{
                fill: [
                  colors.c1,
                  colors.c1,
                  colors.c1,
                  colors.c4,
                  colors.c4,
                  colors.c1,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_1_head">
            <path
              className="cls-3"
              d="M13.15,3.83c0,1.85-1.32,3.4-3.09,3.76-.25.05-.51.08-.77.08s-.53-.03-.78-.08c-1.76-.36-3.08-1.9-3.08-3.75,0-2.11,1.73-3.83,3.86-3.83s3.86,1.72,3.86,3.83Z"
            />
          </g>
        </motion.g>
        <motion.g
          animate={{
            x: [0, -14.5, -14.5, 14.5, 14.5, 0],
            y: [0, -9.4, -9.4, -9.4, -9.4, 0],
            scale: [1, 0.74, 0.74, 0.74, 0.74, 1],
          }}
          transition={{
            ease: "linear",
            times: [0, 0.2, 0.4, 0.6, 0.8, 1],
            duration: 6,
            repeat: Infinity,
            repeatDelay: 1.2,
          }}
        >
          <g id="human_2_bottom_2">
            <motion.ellipse
              cx="24"
              cy="41.67"
              rx="12.55"
              ry="6.33"
              animate={{
                fill: [
                  colors.c1,
                  colors.c3,
                  colors.c3,
                  colors.c3,
                  colors.c3,
                  colors.c1,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_2_bottom">
            <motion.ellipse
              cx="23.98"
              cy="40.78"
              rx="9.06"
              ry="4.16"
              animate={{
                fill: [
                  colors.c2,
                  colors.c4,
                  colors.c4,
                  colors.c4,
                  colors.c4,
                  colors.c2,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
          <g id="human_2_head">
            <path
              className="cls-3"
              d="M29.2,9.03c0,2.51-1.79,4.59-4.17,5.07-.34.07-.69.1-1.05.1s-.71-.04-1.06-.11c-2.37-.48-4.16-2.57-4.16-5.07,0-2.86,2.34-5.18,5.22-5.18s5.22,2.32,5.22,5.18Z"
            />
            <motion.path
              d="M29.99,28.84c-.51,1.31-1.33,2.12-1.33,2.12-.22,1.88-.43,3.43-.63,4.72-.07.48-.15.92-.22,1.33-.69,4.01-1.18,4.66-1.18,4.66h-5.31s-.48-.65-1.18-4.66c-.07-.41-.14-.85-.22-1.33-.2-1.28-.41-2.84-.63-4.72,0,0-.81-.81-1.32-2.12,0,0-1.22-4.44-.51-11.41,0,0,.54-1.34,5.48-2.17.34.06.69.09,1.05.09s.7-.04,1.04-.09c4.93.83,5.47,2.17,5.47,2.17.71,6.97-.51,11.41-.51,11.41Z"
              animate={{
                fill: [
                  colors.c4,
                  colors.c1,
                  colors.c1,
                  colors.c1,
                  colors.c1,
                  colors.c4,
                ],
              }}
              transition={{
                ease: "linear",
                times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1.2,
              }}
            />
          </g>
        </motion.g>
      </svg>
    </span>
  )
}

export default RecommendationsIcon
